__turbopack_context__.v({
  "checkboxContainer": "Step3CredencialesForm-module__3TYwUG__checkboxContainer",
  "checkboxInput": "Step3CredencialesForm-module__3TYwUG__checkboxInput",
  "eyeToggleBtn": "Step3CredencialesForm-module__3TYwUG__eyeToggleBtn",
  "finalizarBtn": "Step3CredencialesForm-module__3TYwUG__finalizarBtn",
  "formContainer": "Step3CredencialesForm-module__3TYwUG__formContainer",
  "formWrapper": "Step3CredencialesForm-module__3TYwUG__formWrapper",
  "helpBtn": "Step3CredencialesForm-module__3TYwUG__helpBtn",
  "highlightMarker": "Step3CredencialesForm-module__3TYwUG__highlightMarker",
  "highlightSvg": "Step3CredencialesForm-module__3TYwUG__highlightSvg",
  "inputError": "Step3CredencialesForm-module__3TYwUG__inputError",
  "inputField": "Step3CredencialesForm-module__3TYwUG__inputField",
  "passwordWrapper": "Step3CredencialesForm-module__3TYwUG__passwordWrapper",
  "stepperContainer": "Step3CredencialesForm-module__3TYwUG__stepperContainer",
  "stepperNav": "Step3CredencialesForm-module__3TYwUG__stepperNav",
  "volverBtn": "Step3CredencialesForm-module__3TYwUG__volverBtn",
});
